"use strict";

function t(t, r) {
  return t(r = {
    exports: {}
  }, r.exports), r.exports;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var r = t(function (t) {
  function r(e) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = r = function r(t) {
      return typeof t;
    } : t.exports = r = function r(t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, r(e);
  }
  t.exports = r;
});
var e = function e(t, r) {
    if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
  },
  n = t(function (t) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, r) {
        return t.__proto__ = r, t;
      }, r(e, n);
    }
    t.exports = r;
  });
var o = function o(t, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), r && n(t, r);
};
var i = function i(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
};
var a = function a(t, e) {
    return !e || "object" !== r(e) && "function" != typeof e ? i(t) : e;
  },
  c = t(function (t) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }
    t.exports = r;
  });
var u = function u(t) {
  return -1 !== Function.toString.call(t).indexOf("[native code]");
};
var f = function f() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  },
  l = t(function (t) {
    function r(e, o, i) {
      return f() ? t.exports = r = Reflect.construct : t.exports = r = function r(t, _r, e) {
        var o = [null];
        o.push.apply(o, _r);
        var i = new (Function.bind.apply(t, o))();
        return e && n(i, e.prototype), i;
      }, r.apply(null, arguments);
    }
    t.exports = r;
  });
function s(t) {
  var r = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();
  return function () {
    var e,
      n = c(t);
    if (r) {
      var o = c(this).constructor;
      e = Reflect.construct(n, arguments, o);
    } else e = n.apply(this, arguments);
    return a(this, e);
  };
}
var p = function (t) {
    function r(t) {
      var o;
      return e(this, r), (o = n.call(this, t)).name = "ParamValidationError", o;
    }
    o(r, t);
    var n = s(r);
    return r;
  }(t(function (t) {
    function r(e) {
      var o = "function" == typeof Map ? new Map() : void 0;
      return t.exports = r = function r(t) {
        if (null === t || !u(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== o) {
          if (o.has(t)) return o.get(t);
          o.set(t, r);
        }
        function r() {
          return l(t, arguments, c(this).constructor);
        }
        return r.prototype = Object.create(t.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), n(r, t);
      }, r(e);
    }
    t.exports = r;
  })(Error)),
  h = {
    FUNCTION: r(function () {}),
    NUMBER: r(1),
    BOOLEAN: r(!0),
    STRING: r("string"),
    OBJECT: r({})
  },
  y = function y(t, e) {
    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "UNDEFINED_FIELD",
      o = !(3 < arguments.length && void 0 !== arguments[3]) || arguments[3];
    if (e && void 0 === h[e.toUpperCase()]) throw new p("Invalid field ".concat(n, " type, ").concat(e, " is invalid ").concat(r(t), ". ").concat(n, " is a ").concat(o ? "required" : "not required", " parameter"));
    if (r(t) !== e && (o || void 0 !== t && !o)) throw new p("Invalid ".concat(n, " param, expected ").concat(e, " and received ").concat(r(t), ". ").concat(n, " is a ").concat(o ? "required" : "not required", " parameter"));
  },
  v = function v(t, r, e) {
    return y(t, h.BOOLEAN, r, e);
  },
  d = function d(t, r, e) {
    return y(t, h.STRING, r, e);
  },
  m = function m(t, r, e) {
    return y(t, h.FUNCTION, r, e);
  },
  g = function g(t, r, e) {
    return y(t, h.OBJECT, r, e);
  },
  w = function w(t, r, e) {
    return y(t, h.NUMBER, r, e);
  },
  b = {
    isBoolean: function isBoolean() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return v.apply(void 0, r.concat([!1]));
    },
    isString: function isString() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return d.apply(void 0, r.concat([!1]));
    },
    isFunction: function isFunction() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return m.apply(void 0, r.concat([!1]));
    },
    isObject: function isObject() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return g.apply(void 0, r.concat([!1]));
    },
    isNumber: function isNumber() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return w.apply(void 0, r.concat([!1]));
    }
  },
  x = g,
  E = function E(t) {
    return t && t.inner && t.inner.reduce(function (t, r) {
      return t[r.path] = r.message, t;
    }, {});
  },
  O = function O(t) {
    return x(t, "schema"), function (r) {
      try {
        t.validateSync(r, {
          abortEarly: !1
        });
      } catch (t) {
        if ("ValidationError" === t.name) return E(t);
        throw new Error(t);
      }
    };
  },
  L = t(function (t) {
    var r = function (t) {
      var r,
        e = Object.prototype,
        n = e.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";
      function u(t, r, e) {
        return Object.defineProperty(t, r, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[r];
      }
      try {
        u({}, "");
      } catch (t) {
        u = function u(t, r, e) {
          return t[r] = e;
        };
      }
      function f(t, r, e, n) {
        var o = r && r.prototype instanceof d ? r : d,
          i = Object.create(o.prototype),
          a = new N(n || []);
        return i._invoke = function (t, r, e) {
          var n = s;
          return function (o, i) {
            if (n === h) throw new Error("Generator is already running");
            if (n === y) {
              if ("throw" === o) throw i;
              return P();
            }
            for (e.method = o, e.arg = i;;) {
              var a = e.delegate;
              if (a) {
                var c = _(a, e);
                if (c) {
                  if (c === v) continue;
                  return c;
                }
              }
              if ("next" === e.method) e.sent = e._sent = e.arg;else if ("throw" === e.method) {
                if (n === s) throw n = y, e.arg;
                e.dispatchException(e.arg);
              } else "return" === e.method && e.abrupt("return", e.arg);
              n = h;
              var u = l(t, r, e);
              if ("normal" === u.type) {
                if (n = e.done ? y : p, u.arg === v) continue;
                return {
                  value: u.arg,
                  done: e.done
                };
              }
              "throw" === u.type && (n = y, e.method = "throw", e.arg = u.arg);
            }
          };
        }(t, e, a), i;
      }
      function l(t, r, e) {
        try {
          return {
            type: "normal",
            arg: t.call(r, e)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      t.wrap = f;
      var s = "suspendedStart",
        p = "suspendedYield",
        h = "executing",
        y = "completed",
        v = {};
      function d() {}
      function m() {}
      function g() {}
      var w = {};
      w[i] = function () {
        return this;
      };
      var b = Object.getPrototypeOf,
        x = b && b(b(R([])));
      x && x !== e && n.call(x, i) && (w = x);
      var E = g.prototype = d.prototype = Object.create(w);
      function O(t) {
        ["next", "throw", "return"].forEach(function (r) {
          u(t, r, function (t) {
            return this._invoke(r, t);
          });
        });
      }
      function L(t, r) {
        var e;
        this._invoke = function (o, i) {
          function a() {
            return new r(function (e, a) {
              !function e(o, i, a, c) {
                var u = l(t[o], t, i);
                if ("throw" !== u.type) {
                  var f = u.arg,
                    s = f.value;
                  return s && "object" == typeof s && n.call(s, "__await") ? r.resolve(s.__await).then(function (t) {
                    e("next", t, a, c);
                  }, function (t) {
                    e("throw", t, a, c);
                  }) : r.resolve(s).then(function (t) {
                    f.value = t, a(f);
                  }, function (t) {
                    return e("throw", t, a, c);
                  });
                }
                c(u.arg);
              }(o, i, e, a);
            });
          }
          return e = e ? e.then(a, a) : a();
        };
      }
      function _(t, e) {
        var n = t.iterator[e.method];
        if (n === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = r, _(t, e), "throw" === e.method)) return v;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return v;
        }
        var o = l(n, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, v;
        var i = o.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = r), e.delegate = null, v) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, v);
      }
      function S(t) {
        var r = {
          tryLoc: t[0]
        };
        1 in t && (r.catchLoc = t[1]), 2 in t && (r.finallyLoc = t[2], r.afterLoc = t[3]), this.tryEntries.push(r);
      }
      function j(t) {
        var r = t.completion || {};
        r.type = "normal", delete r.arg, t.completion = r;
      }
      function N(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(S, this), this.reset(!0);
      }
      function R(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var o = -1,
              a = function e() {
                for (; ++o < t.length;) {
                  if (n.call(t, o)) return e.value = t[o], e.done = !1, e;
                }
                return e.value = r, e.done = !0, e;
              };
            return a.next = a;
          }
        }
        return {
          next: P
        };
      }
      function P() {
        return {
          value: r,
          done: !0
        };
      }
      return m.prototype = E.constructor = g, g.constructor = m, m.displayName = u(g, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === m || "GeneratorFunction" === (r.displayName || r.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, u(t, c, "GeneratorFunction")), t.prototype = Object.create(E), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, O(L.prototype), L.prototype[a] = function () {
        return this;
      }, t.AsyncIterator = L, t.async = function (r, e, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new L(f(r, e, n, o), i);
        return t.isGeneratorFunction(e) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, O(E), u(E, c, "Generator"), E[i] = function () {
        return this;
      }, E.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var r = [];
        for (var e in t) {
          r.push(e);
        }
        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }
          return e.done = !0, e;
        };
      }, t.values = R, N.prototype = {
        constructor: N,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(j), !t) for (var e in this) {
            "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = r);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;
          function o(n, o) {
            return c.type = "throw", c.arg = t, e.next = n, o && (e.method = "next", e.arg = r), !!o;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
              c = a.completion;
            if ("root" === a.tryLoc) return o("end");
            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                f = n.call(a, "finallyLoc");
              if (u && f) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!f) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, r) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var o = this.tryEntries[e];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= r && r <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = r, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
        },
        complete: function complete(t, r) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), v;
        },
        finish: function finish(t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var e = this.tryEntries[r];
            if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), j(e), v;
          }
        },
        catch: function _catch(t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var e = this.tryEntries[r];
            if (e.tryLoc === t) {
              var n = e.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                j(e);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, n) {
          return this.delegate = {
            iterator: R(t),
            resultName: e,
            nextLoc: n
          }, "next" === this.method && (this.arg = r), v;
        }
      }, t;
    }(t.exports);
    try {
      regeneratorRuntime = r;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  });
function _(t, r, e, n, o, i, a) {
  try {
    var c = t[i](a),
      u = c.value;
  } catch (t) {
    return void e(t);
  }
  c.done ? r(u) : Promise.resolve(u).then(n, o);
}
var S = function S(t) {
    return function () {
      var r = this,
        e = arguments;
      return new Promise(function (n, o) {
        var i = t.apply(r, e);
        function a(t) {
          _(i, n, o, a, c, "next", t);
        }
        function c(t) {
          _(i, n, o, a, c, "throw", t);
        }
        a(void 0);
      });
    };
  },
  j = function j(t) {
    return x(t, "schema"), function () {
      var r = S(L.mark(function r(e) {
        return L.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return r.prev = 0, r.next = 3, t.validate(e, {
                  abortEarly: !1
                });
              case 3:
                return r.abrupt("return", void 0);
              case 6:
                if (r.prev = 6, r.t0 = r.catch(0), "ValidationError" !== r.t0.name) {
                  r.next = 10;
                  break;
                }
                return r.abrupt("return", E(r.t0));
              case 10:
                throw new Error(r.t0);
              case 11:
              case "end":
                return r.stop();
            }
          }
        }, r, null, [[0, 6]]);
      }));
      return function () {
        return r.apply(this, arguments);
      };
    }();
  };
var N = function N(t) {
  if (Array.isArray(t)) return t;
};
var R = function R(t, r) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
    var e = [],
      n = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = t[Symbol.iterator](); !(n = (a = c.next()).done) && (e.push(a.value), !r || e.length !== r); n = !0) {
        ;
      }
    } catch (t) {
      o = !0, i = t;
    } finally {
      try {
        n || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return e;
  }
};
var P = function P(t, r) {
  (null == r || r > t.length) && (r = t.length);
  for (var e = 0, n = new Array(r); e < r; e++) {
    n[e] = t[e];
  }
  return n;
};
var A = function A(t, r) {
  if (t) {
    if ("string" == typeof t) return P(t, r);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? P(t, r) : void 0;
  }
};
var T = function T() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var I = function I(t, r) {
    return N(t) || R(t, r) || A(t, r) || T();
  },
  F = function F(t) {
    return {
      type: "object",
      properties: Object.entries(t).reduce(function (t, r) {
        var e = I(r, 2),
          n = e[0],
          o = e[1];
        return t[n] = {
          type: o.type
        }, o.fields && (t[n].properties = F(o.fields)), t;
      }, {})
    };
  },
  k = function k(t) {
    x(t, "schema");
    var r = t.describe();
    return F(r.fields);
  },
  G = function G(t) {
    var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      e = r.async,
      n = void 0 !== e && e;
    return x(t, "schema"), b.isBoolean(n, "async"), function () {
      return {
        formValidator: !n && O(t) || j(t),
        jsonSchema: k(t)
      };
    };
  },
  B = Object.freeze({
    __proto__: null,
    formSchema: G
  });
exports.default = B, exports.formSchema = G;